/** App shell, shared components (forms, tables, map editors), login, account and dashboard. */
export default {
  // Shared components
  'This cannot be undone.': 'Ky veprim nuk mund të kthehet.',
  Create: 'Krijo',
  'Save changes': 'Ruaj ndryshimet',
  'Delete?': 'Të fshihet?',
  'Upload failed': 'Ngarkimi dështoi',
  Replace: 'Zëvendëso',
  Upload: 'Ngarko',
  'Remove {value}': 'Hiq {value}',
  'No results': 'Asnjë rezultat',
  '{from}–{to} of {total}': '{from}–{to} nga {total}',
  'Previous page': 'Faqja e mëparshme',
  'Next page': 'Faqja tjetër',
  'Nothing here yet': 'Ende nuk ka asgjë këtu',
  'Last {n} days': '{n} ditët e fundit',
  '{n} total': 'gjithsej {n}',
  Today: 'Sot',

  // Rich-text editor
  'Write the article…': 'Shkruani artikullin…',
  Bold: 'I trashë',
  Italic: 'I pjerrët',
  'Section heading': 'Nëntitull',
  'Bullet list': 'Listë me pika',
  'Numbered list': 'Listë e numëruar',
  Quote: 'Citat',
  Link: 'Linku',
  'Link URL': 'URL-ja e linkut',
  Undo: 'Zhbëj',
  Redo: 'Ribëj',

  // Map shape editor
  'Draw {shape}': 'Vizato {shape}',
  'Redraw {shape}': 'Rivizato {shape}',
  'Draw area': 'Vizato sipërfaqen',
  'Redraw area': 'Rivizato sipërfaqen',
  'Draw route': 'Vizato rrugën',
  'Redraw route': 'Rivizato rrugën',
  Clear: 'Pastro',
  'Click to add corners, click the first corner to close.':
    'Klikoni për të shtuar kulme; klikoni kulmin e parë për ta mbyllur.',
  'Click to add points, double-click to finish.':
    'Klikoni për të shtuar pika; klikoni dy herë për ta përfunduar.',

  // Login and account
  'Could not sign in': 'Kyçja dështoi',
  'Admin panel': 'Paneli i administrimit',
  'Sign in to manage the network': 'Kyçuni për të menaxhuar rrjetin',
  'E-mail': 'E-mail',
  Password: 'Fjalëkalimi',
  'Keep me signed in for {n} days': 'Më mbaj të kyçur për {n} ditë',
  'Sign in': 'Kyçu',
  'Change password': 'Ndrysho fjalëkalimin',
  'Password changed. Please sign in again.': 'Fjalëkalimi u ndryshua. Ju lutemi kyçuni përsëri.',
  'Current password': 'Fjalëkalimi aktual',
  'New password': 'Fjalëkalimi i ri',

  // Dashboard
  'Live overview of the network': 'Pasqyra e rrjetit në kohë reale',
  'Buses on route': 'Busat në qarkullim',
  'of {n} vehicle': 'nga {n} automjet',
  'of {n} vehicles': 'nga {n} automjete',
  'Reports to answer': 'Raporte pa përgjigje',
  '{n} open': '{n} të hapura',
  'Live map': 'Harta në kohë reale',
  '{n} bus': '{n} bus',
  '{n} buses': '{n} busa',
  'updated {time}': 'përditësuar në {time}',
  'Connecting…': 'Duke u lidhur…',
  'Recent activity': 'Aktiviteti i fundit',
  system: 'sistemi',
  'Nothing in the last {n} hours': 'Asgjë në {n} orët e fundit',

  // Dashboard activity: "<user> created the bus"
  'created {entity}': 'krijoi {entity}',
  'updated {entity}': 'përditësoi {entity}',
  'deleted {entity}': 'fshiu {entity}',
  'archived {entity}': 'arkivoi {entity}',
  'restored {entity}': 'riktheu {entity}',
  'replied to {entity}': 'dha përgjigje për {entity}',
  'uploaded {entity}': 'ngarkoi {entity}',
  'signed in': 'u kyç',
  'changed their password': 'ndryshoi fjalëkalimin',
  'the station ad': 'reklamën në stacion',
  'the bus': 'busin',
  'the campaign': 'fushatën',
  'a file': 'një skedar',
  'the point of interest': 'pikën e interesit',
  'the news article': 'lajmin',
  'the notification': 'njoftimin',
  'the out-of-service area': 'zonën jashtë funksionit',
  'the map pin': 'pinin në hartë',
  'the report': 'raportin',
  'the timetable': 'orarin',
  'the station': 'stacionin',
  'the user': 'përdoruesin',
  '{n} in service': '{n} në qarkullim',
  'No matches': 'Asnjë rezultat',
  'Search campaign…': 'Kërko fushatën…',
  'Add a station: type its name…': 'Shto një stacion: shkruani emrin…',
  'Also on: {lines}': 'Edhe në: {lines}',
  'Search station…': 'Kërko stacionin…',
  'Drag a point to move it, drag a small white point to add one, right-click a point to delete it.':
    'Tërhiqni një pikë për ta zhvendosur, tërhiqni një pikë të vogël të bardhë për të shtuar një të re, klikoni me të djathtën një pikë për ta fshirë.',
  'Draw the shape on the map.': 'Vizatoni formën në hartë.',
  'Show this bus': 'Shfaqe këtë bus',
  'Show this station': 'Shfaqe këtë stacion',
  '{p} vs yesterday at this time': '{p} krahasuar me dje në këtë orë',
  Yesterday: 'Dje',
  'No requests recorded yet.': 'Ende nuk ka kërkesa të regjistruara.',
  'Average bus speed': 'Shpejtësia mesatare e autobusëve',
  'Bigger, stronger dots: buses spend more time there.':
    'Pika më të mëdha dhe më të forta: autobusët qëndrojnë më gjatë aty.',
  'Where passengers use the app': 'Ku e përdorin pasagjerët aplikacionin',
  few: 'pak',
  many: 'shumë',
  'Km driven today': 'Km të përshkuara sot',
  'App requests today': 'Kërkesa në aplikacion sot',
  'Map layer': 'Shtresa e hartës',
  'Live buses': 'Autobusët drejtpërdrejt',
  'Heatmap: bus speed': 'Harta e nxehtësisë: shpejtësia',
  'Heatmap: passengers': 'Harta e nxehtësisë: pasagjerët',
  Period: 'Periudha',
  'Time of day': 'Koha e ditës',
  'All day': 'Gjithë ditën',
  'Morning (6–10)': 'Mëngjes (6–10)',
  'Midday (10–15)': 'Mesditë (10–15)',
  'Afternoon (15–19)': 'Pasdite (15–19)',
  'Evening (19–24)': 'Mbrëmje (19–24)',
  'Night (0–6)': 'Natë (0–6)',
  'Buses to check ({n})': "Autobusë për t'u kontrolluar ({n})",
  'Buses on route, by hour': 'Autobusë në rrugë, sipas orës',
  'App requests, by hour': 'Kërkesa në aplikacion, sipas orës',
  'Most asked stations (7 days)': 'Stacionet më të kërkuara (7 ditë)',
  Drives: 'Qarkullon në',
  Since: 'Që nga',
  'Hidden in the app': 'I fshehur në aplikacion',
  'assigned a line to {entity}': 'caktoi linjën për {entity}',
  'the direction': 'drejtimin',
  'the line': 'linjën',
  'Stop {n} of this direction': 'Stacioni {n} i këtij drejtimi',
  'Not on this direction': 'Nuk është në këtë drejtim',
  'Remove from direction': 'Hiqe nga drejtimi',
  'Add to direction': 'Shtoje në drejtim',
  'Search direction…': 'Kërko drejtimin…',
  'Choose a direction first': 'Zgjidhni së pari drejtimin',
  'Assigned to {own}, but in the last 30 minutes it drove {other} ({p} of positions; {q} on its own line).':
    'I caktuar në {own}, por në 30 minutat e fundit ka qarkulluar në {other} ({p} e pozitave; {q} në linjën e vet).',
  'Has no line, but in the last 30 minutes it drove {other} ({p} of positions).':
    'Nuk ka linjë, por në 30 minutat e fundit ka qarkulluar në {other} ({p} e pozitave).',
  'Off its route: only {q} of the last 30 minutes on {own}. A detour, or a line drawn differently from where buses drive.':
    'Jashtë rrugës: vetëm {q} e 30 minutave të fundit në {own}. Devijim, ose linjë e vizatuar ndryshe nga ku qarkullojnë autobusët.',
  'All buses drive their line.': 'Të gjithë autobusët qarkullojnë në linjën e tyre.',
  'Wrong line': 'Linjë e gabuar',
  'No line, drives one': 'Pa linjë, por qarkullon në një',
  'Little of the last 30 minutes on its own line, and no other line fits: a detour, a trip to the depot, or a line with a wrongly drawn direction.':
    'Pak nga 30 minutat e fundit në linjën e vet dhe asnjë linjë tjetër nuk përputhet: devijim, rrugë drejt depos ose linjë me drejtim të vizatuar gabim.',
  'In the last 30 minutes the bus drove another line than the one it is assigned to.':
    'Në 30 minutat e fundit autobusi ka qarkulluar në një linjë tjetër nga ajo ku është caktuar.',
  'The bus has no line, but in the last 30 minutes it drove one.':
    'Autobusi nuk ka linjë, por në 30 minutat e fundit ka qarkulluar në njërën.',
  'Assigned line': 'Linja e caktuar',
  'On its line': 'Në linjën e vet',
} satisfies Record<string, string>;
